import { ContentSwitcherBySkin } from 'components/Atoms/ContentSwitcherBySkin'
import { SKINS } from 'constants/skins'
import { LvgWsbGameHeader } from './LvgWsbGameHeader'
import { LvgYoloGameHeader } from './LvgYoloGameHeader'

const GRAPH_HEADER_BY_SKIN = {
  [SKINS.WSB]: <LvgWsbGameHeader />,
  [SKINS.DEFAULT]: <LvgYoloGameHeader />,
}

export const LvgGameHeader = () => {
  return <ContentSwitcherBySkin noWrapper componentsBySkin={GRAPH_HEADER_BY_SKIN} />
}
